export default [
  {
    path: '/lpcchi',
    component: () =>import('./pages/index.vue'),
    meta: { title: 'LPC池' },
  }
]
